import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _9bf3c9d6 = () => interopDefault(import('..\\pages\\have-a-card.vue' /* webpackChunkName: "pages_have-a-card" */))
const _5c247419 = () => interopDefault(import('..\\pages\\have-a-card\\enrollment.vue' /* webpackChunkName: "pages_have-a-card_enrollment" */))
const _c879e3f8 = () => interopDefault(import('..\\pages\\have-a-card\\rejection.vue' /* webpackChunkName: "pages_have-a-card_rejection" */))
const _5805d1be = () => interopDefault(import('..\\pages\\have-a-card\\success.vue' /* webpackChunkName: "pages_have-a-card_success" */))
const _763cab27 = () => interopDefault(import('..\\pages\\need-a-card.vue' /* webpackChunkName: "pages_need-a-card" */))
const _39c69814 = () => interopDefault(import('..\\pages\\need-a-card\\eligibility.vue' /* webpackChunkName: "pages_need-a-card_eligibility" */))
const _5eb9849e = () => interopDefault(import('..\\pages\\need-a-card\\error.vue' /* webpackChunkName: "pages_need-a-card_error" */))
const _02676903 = () => interopDefault(import('..\\pages\\need-a-card\\insurance.vue' /* webpackChunkName: "pages_need-a-card_insurance" */))
const _478d3e4d = () => interopDefault(import('..\\pages\\need-a-card\\patient-information.vue' /* webpackChunkName: "pages_need-a-card_patient-information" */))
const _9d5fc29c = () => interopDefault(import('..\\pages\\need-a-card\\rejection.vue' /* webpackChunkName: "pages_need-a-card_rejection" */))
const _6d5b35ec = () => interopDefault(import('..\\pages\\need-a-card\\success.vue' /* webpackChunkName: "pages_need-a-card_success" */))
const _2753db3d = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _2761f2be = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _277e21c0 = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _278c3941 = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _5c3a167e = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _53af2b66 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/have-a-card",
    component: _9bf3c9d6,
    name: "have-a-card",
    children: [{
      path: "enrollment",
      component: _5c247419,
      name: "have-a-card-enrollment"
    }, {
      path: "rejection",
      component: _c879e3f8,
      name: "have-a-card-rejection"
    }, {
      path: "success",
      component: _5805d1be,
      name: "have-a-card-success"
    }]
  }, {
    path: "/need-a-card",
    component: _763cab27,
    name: "need-a-card",
    children: [{
      path: "eligibility",
      component: _39c69814,
      name: "need-a-card-eligibility"
    }, {
      path: "error",
      component: _5eb9849e,
      name: "need-a-card-error"
    }, {
      path: "insurance",
      component: _02676903,
      name: "need-a-card-insurance"
    }, {
      path: "patient-information",
      component: _478d3e4d,
      name: "need-a-card-patient-information"
    }, {
      path: "rejection",
      component: _9d5fc29c,
      name: "need-a-card-rejection"
    }, {
      path: "success",
      component: _6d5b35ec,
      name: "need-a-card-success"
    }]
  }, {
    path: "/errors/400",
    component: _2753db3d,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _2761f2be,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _277e21c0,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _278c3941,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _5c3a167e,
    name: "errors-500"
  }, {
    path: "/",
    component: _53af2b66,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
